export enum DPUserStatus {
  InProgress = 1,
  Completed = 2,
  NotRequired = 3,
}
